/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Command_CalendarInputs */

const he_command_calendar = /** @type {(inputs: Command_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לוח שנה`)
};

const en_command_calendar = /** @type {(inputs: Command_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendar`)
};

/**
* | output |
* | --- |
* | "Calendar" |
*
* @param {Command_CalendarInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const command_calendar = /** @type {((inputs?: Command_CalendarInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Command_CalendarInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_command_calendar(inputs)
	return en_command_calendar(inputs)
});